/*
State
0: Kalkulation
1: Ausführung
2: Archiviert
3: Beendet
4: Gelöscht
-->
*/
module.exports = Object.freeze({
  MY_CONSTANT: 'some value',
  ANOTHER_CONSTANT: 'another value',
  DEMO_PROJECT_BUDGET_LIMIT: 250000,
  THEME_LIGHTNESS_THRESHOLD: 0.8,
  PROJECT_STATES: {
    KALKULATION: 0,
    AUSFUEHRUNG: 1,
    ARCHIVIERT: 2,
    BEENDET: 3,
    GELOESCHT: 4
  }
});

/*

// how to use:

{{ CONSTANTS.MY_CONSTANT }}

console.log(this.CONSTANT.MY_CONSTANT); // 'some value'

*/
